import React from 'react';
import {Flex} from '/app/src/component';
import SVG from 'react-inlinesvg';
import Theme from '/app/src/theme';

const textStyle = {
    color: "Black_M",
    fontSize: "20px",
    vAlignContent: "center"
}

const listContainer = {
    padding: "20px 0px"
}

const itemContainer = {
    margin: "10px 0px"
}

const FeatureList = ({iconList, textList}) => (
    <Flex {...listContainer}>
        <Flex column>
        { iconList.map((iconSrc, i) => _featureItem(iconSrc, textList[i], i)) }
        </Flex>
    </Flex>
)

const _featureItem = (iconSrc, text, i) => (
    <Flex {...itemContainer} key={i}>
        <Flex>
            <SVG
                cacheGetRequests={true}
                src={iconSrc}
                style={{
                    fill: Theme.colors.JibberPurple_L,
                    width: "35px",
                    height: "35px",
                    marginRight: "15px"
                    }}/>
        </Flex>
        <Flex {...textStyle}>
            {text}
        </Flex>
    </Flex>
)

export default FeatureList;



// WEBPACK FOOTER //
// ./src/component/Modal/UpgradeModal/FeatureList.js